export default __webpack_public_path__ + "static/media/grad.4c2b4abd.jpg";